<template>
  <div class="rightModal">
    <div class="info"
         v-html="$t('global.areYouSure')"></div>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'

export default {
  name: 'DetachFromServer',
  props: {
    confirmModal: Boolean,
    selectedId: String,
  },
  methods: {
    confirm() {
      ApiService.delete(`iaas/virtual-network-cards/${this.selectedId}/detach`)
        .then(({ data }) => {
          this.$emit('resetDetailForm', true)
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
          this.$emit('resetDetailForm', false)
        })
    },
  },
  watch: {
    confirmModal(newVal) {
      if (newVal) {
        this.confirm()
      }
    },
  },
}
</script> 